import { IDeleteLessonRequest } from "api/models/request/IDeleteLessonRequest";
import { deleteLesson } from "api/services/lesson-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { useCallback } from "react";

export const useDeleteLesson = () => {
    const { callAPI, loading } = useWorkspaceApiCall<IDeleteLessonRequest, any>(deleteLesson, 'lesson.deleteLessonSuccess', 'lesson.deleteLessonError');
    
    const deleteLessonById = useCallback(async (lessonId: string) => {
        return await callAPI({ lessonId });
    }, [callAPI]);

    return { deleteLesson: deleteLessonById, deleteLessonPending: loading }
}